const registry = new Set<{ clear: () => void }>();

/**
 * Last good response per screen and filter, kept for the browser session. Revisiting a tab
 * renders it at once while the fresh request runs; it is never used instead of that request.
 * Every cache is emptied when the signed-in user changes (see clearViewCaches).
 */
export function viewCache<T>(limit = 50) {
  const entries = new Map<string, T>();
  const cache = {
    get: (key: string) => entries.get(key),
    set: (key: string, value: T) => {
      entries.delete(key);
      entries.set(key, value);
      if (entries.size > limit) entries.delete(entries.keys().next().value!);
    },
    delete: (key: string) => entries.delete(key),
    clear: () => entries.clear(),
  };
  registry.add(cache);
  return cache;
}

/** Drops every cached view: on sign-in, sign-out or a different user. */
export function clearViewCaches() {
  for (const cache of registry) cache.clear();
}
